import { useTheme } from "next-themes";
import { Toaster as Sonner, toast } from "sonner";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      className="toaster group"
      closeButton
      duration={750}
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-card group-[.toaster]:text-foreground group-[.toaster]:border-2 group-[.toaster]:border-primary group-[.toaster]:shadow-2xl group-[.toaster]:shadow-primary/20 group-[.toaster]:backdrop-blur-sm",
          description: "group-[.toast]:text-foreground/90",
          actionButton: 
            "group-[.toast]:bg-gradient-to-r group-[.toast]:from-primary group-[.toast]:to-accent group-[.toast]:text-primary-foreground group-[.toast]:font-semibold group-[.toast]:shadow-md group-[.toast]:shadow-primary/30 hover:group-[.toast]:opacity-90 group-[.toast]:transition-opacity",
          cancelButton: 
            "group-[.toast]:bg-muted group-[.toast]:text-foreground group-[.toast]:border group-[.toast]:border-border hover:group-[.toast]:bg-muted/80 group-[.toast]:transition-colors",
          success: "group-[.toast]:border-success group-[.toast]:bg-card",
          error: "group-[.toast]:border-destructive group-[.toast]:bg-card",
          warning: "group-[.toast]:border-warning group-[.toast]:bg-card",
          info: "group-[.toast]:border-primary group-[.toast]:bg-card",
          closeButton: "group-[.toast]:bg-card group-[.toast]:border-border group-[.toast]:text-foreground hover:group-[.toast]:bg-muted",
        },
      }}
      {...props}
    />
  );
};

export { Toaster, toast };
